enum Environment {
    DEVELOPMENT = 'development',

    STAGING = 'staging',
    STAGING_QA = 'staging-qa',

    AUDIT = 'audit',
    INTEGRATIONS = 'integrations',
    DEMO = 'demo',

    PROD_BALTNETA = 'prod-baltneta',
    PROD_AWS_PAR = 'prod-aws-par',
    PROD_AWS_GLS = 'prod-aws-gls',
    PROD_AZURE_CAP = 'prod-azure-cap',
}

export const envConfig = {
    version: _globalConfig.version,
    environment: _globalConfig.environment,
    apiUrl: _globalConfig.apiUrl,
    wsUrl: _globalConfig.wsUrl,
    buildType: _globalConfig.buildType,
    chatConfig: _globalConfig.chatConfig,

    isDevEnv: _globalConfig.environment === Environment.DEVELOPMENT,

    isStagingEnv: _globalConfig.environment === Environment.STAGING,
    isStagingQAEnv: _globalConfig.environment === Environment.STAGING_QA,

    isTestingEnv: [Environment.DEVELOPMENT, Environment.STAGING, Environment.STAGING_QA].includes(
        _globalConfig.environment as Environment,
    ),

    isAuditEnv: _globalConfig.environment === Environment.AUDIT,
    isIntegrationsEnv: _globalConfig.environment === Environment.INTEGRATIONS,
    isDemoEnv: _globalConfig.environment === Environment.DEMO,

    isBaltnetaEnv: _globalConfig.environment === Environment.PROD_BALTNETA,
    isAwsParEnv: _globalConfig.environment === Environment.PROD_AWS_PAR,
    isAzureCapEnv: _globalConfig.environment === Environment.PROD_AZURE_CAP,
    isAwsGlsEnv: _globalConfig.environment === Environment.PROD_AWS_GLS,

    isProductionEnv: [
        Environment.PROD_BALTNETA,
        Environment.PROD_AWS_PAR,
        Environment.PROD_AZURE_CAP,
        Environment.PROD_AWS_GLS,
    ].includes(_globalConfig.environment as Environment),
};
